import { useEffect, useMemo } from "react";
import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { ShowAlert, showConfirmationDialog } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const cols: string[] = ["#", "Name", "Multiple Options", "Actions"];

const AddOnsListing = observer(() => {
  const { addOnStore } = useStores();
  const { addOns, fetchAddOns, setEditAddOn, deleteAddOn } = addOnStore;

  useEffect(() => {
    fetchAddOns();
  }, []);

  const addOnsList = useMemo(() => {
    return addOns;
  }, [addOns]);

  const handleDelete = (addOnId: number) => {
    showConfirmationDialog(() => {
      deleteAddOn(addOnId, (res: boolean) => {
        if (res) {
          ShowAlert.Success("Add-On deleted successfully.");
          fetchAddOns();
        } else ShowAlert.Error("Request failed. Please try again.");
      });
    });
  };

  return (
    <table className="table table-responsive table-striped shadow-lg">
      <thead>
        <tr>
          {cols.map((c, i) => (
            <th
              scope="col"
              className="border-top-0 border-start-0 border-end-0 border-3 border-warning"
              key={i}
            >
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {addOnsList?.map((addOn, i) => (
          <tr key={i}>
            <th>{i + 1}</th>
            <td className="text-start">{addOn.addOnName}</td>
            <td>{addOn.canChooseMultiple ? "Yes" : "No"}</td>
            <td>
              <button className="btn" onClick={() => setEditAddOn(addOn)}>
                <FontAwesomeIcon icon={faEdit} className="text-primary" />
              </button>
              <button
                className="btn"
                onClick={() => handleDelete(addOn.addOnId)}
              >
                <FontAwesomeIcon icon={faTrash} className="text-danger" />
              </button>
            </td>
          </tr>
        ))}
        {!addOnsList?.length && (
          <tr>
            <th colSpan={4} className="text-center">
              No data available.
            </th>
          </tr>
        )}
      </tbody>
    </table>
  );
});

export default AddOnsListing;
